/*
 * CpyName is a mirror of the definitions in the backend cpynames package.
 */
export const CpyName = {
  BCOutboxGesecInvoice: "businesscentral.outbox.gesecinvoice",
  DynamicsSalesOpportunity: "dynamics.dynamicssales.opportunity",
  TextblocksCatalog: "gsm.textblocks.catalog",
  TextblocksDefaultCatalog: "gsm.textblocks.defaultcatalog",
  TextblocksTextblockList: "gsm.textblocks.textblocklist",
  HTZConfirmation: "gsm.htz.confirmation",
  HTZOffer: "gsm.htz.offer",
  HTZOrder: "gsm.htz.order",
  HTZWorkOrder: "gsm.htz.workorder",
  HTZWorkOrderPosition: "gsm.htz.workorderposition",
  HTZReport: "gsm.htz.report",
  ProcessesProcess: "gsm.processes.process",
  RLTCalculation: "gsm.rlt.calculation",
  RLTCertificate: "gsm.rlt.certificate",
  RLTConfirmation: "gsm.rlt.confirmation",
  RLTContract: "gsm.rlt.contract",
  RLTOffer: "gsm.rlt.offer",
  RLTOrder: "gsm.rlt.order",
  RLTWorkOrder: "gsm.rlt.workorder",
  VBSCalculation: "gsm.vbs.calculation",
  VBSCertificate: "gsm.vbs.certificate",
  VBSConfirmation: "gsm.vbs.confirmation",
  VBSContract: "gsm.vbs.contract",
  VBSOffer: "gsm.vbs.offer",
  VBSOrder: "gsm.vbs.order",
  VBSWorkOrder: "gsm.vbs.workorder",
} as const;

export type CpyName = (typeof CpyName)[keyof typeof CpyName];
